import type { Endpoint } from ".";

export const getProperty: Endpoint = {
  id: "getProperty",
  method: "GET",
  path: "/projects/{project_id}/properties/{property_id}",
  summary: "Get property",
  description:
    "Returns a single property row in the project if the caller has access.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
    {
      name: "property_id",
      in: "path",
      required: true,
      description: "UUID of the property.",
      type: "uuid",
    },
  ],
};
